var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstaLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_6575_47105)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.882 46.0868C34.0504 51.8855 22.95 51.2413 15.8578 44.1435C8.0474 36.3327 8.0474 23.6688 15.8578 15.8581C23.6682 8.04731 36.3265 8.04731 44.1422 15.8581C51.9526 23.6688 51.9526 36.3276 44.1422 44.1383",
    stroke: "url(#paint0_linear_6575_47105)",
    strokeWidth: 2.64,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2385 23.2097C34.589 23.2097 34.0662 23.7324 34.0662 24.382C34.0662 25.0316 34.589 25.5491 35.2385 25.5491C35.888 25.5491 36.4056 25.0263 36.4056 24.382C36.4056 23.7377 35.8828 23.2097 35.2385 23.2097Z",
    stroke: "url(#paint1_linear_6575_47105)",
    strokeWidth: 2.64,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.037 25.0842C27.3279 25.0842 25.1206 27.2862 25.1206 30.0007C25.1206 32.7152 27.3279 34.9177 30.037 34.9177C32.7461 34.9177 34.9482 32.7152 34.9482 30.0007C34.9482 27.2862 32.7461 25.0842 30.037 25.0842Z",
    stroke: "url(#paint2_linear_6575_47105)",
    strokeWidth: 2.64,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9818 39.9769H26.0129C22.7071 39.9769 20.019 37.2885 20.019 33.9825V26.0134C20.019 22.7074 22.7071 20.0195 26.0129 20.0195H33.9818C37.2876 20.0195 39.9755 22.7074 39.9755 26.0134V33.9825C39.9755 37.2885 37.2876 39.9769 33.9818 39.9769Z",
    stroke: "url(#paint3_linear_6575_47105)",
    strokeWidth: 2.64,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "soft-light"
    },
    d: "M35.2385 23.2097C34.589 23.2097 34.0662 23.7324 34.0662 24.382C34.0662 25.0316 34.589 25.5491 35.2385 25.5491C35.888 25.5491 36.4056 25.0263 36.4056 24.382C36.4056 23.7377 35.8828 23.2097 35.2385 23.2097Z",
    stroke: "url(#paint4_linear_6575_47105)",
    strokeWidth: 0.88,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "soft-light"
    },
    d: "M30.037 25.0842C27.3279 25.0842 25.1206 27.2862 25.1206 30.0007C25.1206 32.7152 27.3279 34.9177 30.037 34.9177C32.7461 34.9177 34.9482 32.7152 34.9482 30.0007C34.9482 27.2862 32.7461 25.0842 30.037 25.0842Z",
    stroke: "url(#paint5_linear_6575_47105)",
    strokeWidth: 0.88,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "soft-light"
    },
    d: "M33.9818 39.9769H26.0129C22.7071 39.9769 20.019 37.2885 20.019 33.9825V26.0134C20.019 22.7074 22.7071 20.0195 26.0129 20.0195H33.9818C37.2876 20.0195 39.9755 22.7074 39.9755 26.0134V33.9825C39.9755 37.2885 37.2876 39.9769 33.9818 39.9769Z",
    stroke: "url(#paint6_linear_6575_47105)",
    strokeWidth: 0.88,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.882 46.0868C34.0504 51.8855 22.95 51.2413 15.8578 44.1435C8.0474 36.3327 8.0474 23.6688 15.8578 15.8581C23.6682 8.04731 36.3265 8.04731 44.1422 15.8581C51.9526 23.6688 51.9526 36.3276 44.1422 44.1383",
    stroke: "url(#paint7_linear_6575_47105)",
    strokeWidth: 2.64,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2385 23.2097C34.589 23.2097 34.0662 23.7324 34.0662 24.382C34.0662 25.0316 34.589 25.5491 35.2385 25.5491C35.888 25.5491 36.4056 25.0263 36.4056 24.382C36.4056 23.7377 35.8828 23.2097 35.2385 23.2097Z",
    stroke: "url(#paint8_linear_6575_47105)",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.037 25.0842C27.3279 25.0842 25.1206 27.2862 25.1206 30.0007C25.1206 32.7152 27.3279 34.9177 30.037 34.9177C32.7461 34.9177 34.9482 32.7152 34.9482 30.0007C34.9482 27.2862 32.7461 25.0842 30.037 25.0842Z",
    stroke: "url(#paint9_linear_6575_47105)",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9818 39.9769H26.0129C22.7071 39.9769 20.019 37.2885 20.019 33.9825V26.0134C20.019 22.7074 22.7071 20.0195 26.0129 20.0195H33.9818C37.2876 20.0195 39.9755 22.7074 39.9755 26.0134V33.9825C39.9755 37.2885 37.2876 39.9769 33.9818 39.9769Z",
    stroke: "url(#paint10_linear_6575_47105)",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.882 46.0868C34.0504 51.8855 22.95 51.2413 15.8578 44.1435C8.0474 36.3327 8.0474 23.6688 15.8578 15.8581C23.6682 8.04731 36.3265 8.04731 44.1422 15.8581C51.9526 23.6688 51.9526 36.3276 44.1422 44.1383",
    stroke: "url(#paint11_linear_6575_47105)",
    strokeWidth: 0.88,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "soft-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "soft-light"
    },
    d: "M35.2387 23.2097C34.5892 23.2097 34.0664 23.7324 34.0664 24.382C34.0664 25.0316 34.5892 25.5491 35.2387 25.5491C35.8883 25.5491 36.4058 25.0263 36.4058 24.382C36.4058 23.7377 35.883 23.2097 35.2387 23.2097Z",
    stroke: "url(#paint12_linear_6575_47105)",
    strokeWidth: 0.88,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "soft-light"
    },
    d: "M30.0368 25.0842C27.3277 25.0842 25.1204 27.2862 25.1204 30.0007C25.1204 32.7152 27.3277 34.9177 30.0368 34.9177C32.7458 34.9177 34.948 32.7152 34.948 30.0007C34.948 27.2862 32.7458 25.0842 30.0368 25.0842Z",
    stroke: "url(#paint13_linear_6575_47105)",
    strokeWidth: 0.88,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "soft-light"
    },
    d: "M33.9818 39.9769H26.0129C22.7071 39.9769 20.019 37.2885 20.019 33.9825V26.0134C20.019 22.7074 22.7071 20.0195 26.0129 20.0195H33.9818C37.2876 20.0195 39.9755 22.7074 39.9755 26.0134V33.9825C39.9755 37.2885 37.2876 39.9769 33.9818 39.9769Z",
    stroke: "url(#paint14_linear_6575_47105)",
    strokeWidth: 0.88,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_6575_47105",
    x: 0.679932,
    y: 0.679932,
    width: 58.6401,
    height: 58.6399,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_6575_47105"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6575_47105",
    x1: 9.29896,
    y1: 30.0007,
    x2: 50.6905,
    y2: 30.0007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EE7CE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7248"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6575_47105",
    x1: 33.3691,
    y1: 24.3768,
    x2: 37.1026,
    y2: 24.3768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EE7CE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7248"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6575_47105",
    x1: 24.4235,
    y1: 30.001,
    x2: 35.6453,
    y2: 30.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EE7CE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7248"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6575_47105",
    x1: 19.322,
    y1: 30.0009,
    x2: 40.6726,
    y2: 30.0009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EE7CE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7248"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6575_47105",
    x1: 33.8338,
    y1: 24.3768,
    x2: 36.6379,
    y2: 24.3768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EE7CE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7248"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6575_47105",
    x1: 24.8882,
    y1: 30.001,
    x2: 35.1806,
    y2: 30.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EE7CE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7248"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6575_47105",
    x1: 19.7867,
    y1: 30.0009,
    x2: 40.2078,
    y2: 30.0009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EE7CE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7248"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6575_47105",
    x1: 9.29896,
    y1: 30.0007,
    x2: 50.6905,
    y2: 30.0007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EE7CE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7248"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6575_47105",
    x1: 33.3691,
    y1: 24.3768,
    x2: 37.1026,
    y2: 24.3768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EE7CE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7248"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6575_47105",
    x1: 24.4235,
    y1: 30.001,
    x2: 35.6453,
    y2: 30.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EE7CE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7248"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6575_47105",
    x1: 19.322,
    y1: 30.0009,
    x2: 40.6726,
    y2: 30.0009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EE7CE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7248"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6575_47105",
    x1: 9.53427,
    y1: 30.0053,
    x2: 50.4657,
    y2: 30.0053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FFEAFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF4F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_6575_47105",
    x1: 34.0392,
    y1: 24.3797,
    x2: 36.433,
    y2: 24.3797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FFEAFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF4F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_6575_47105",
    x1: 25.0059,
    y1: 30.0023,
    x2: 35.0624,
    y2: 30.0023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FFEAFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF4F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_6575_47105",
    x1: 19.7867,
    y1: 30.0009,
    x2: 40.2078,
    y2: 30.0009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FFEAFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF4F0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaLight);
export default __webpack_public_path__ + "static/media/insta_light.c2c83d0523d73b8fca7142b9a80f872e.svg";
export { ForwardRef as ReactComponent };